import { Injectable } from "@angular/core";
import { MapService } from "./map.service";
import { ActiveService } from "./active.service";
import { MatDialogConfig } from "@angular/material/dialog";


@Injectable({
  providedIn: "root",
})
export class PanoramicService {
  panoramic: any;
  createActive: Boolean = false;

  constructor(
    protected mapService: MapService,
    protected activeService: ActiveService
  ) { }

  setPanoramic(panoramic) {
    this.panoramic = panoramic;
  }

  getPanoramic() {
    return this.panoramic;
  }

  setCreateActive(createActive) {
    this.createActive = createActive;
  }

  getCreateActive() {
    return this.createActive;
  }

  loadScene(xml: string, scenename: string) {
    this.panoramic.call(
      `loadpanoscene(xml/${xml},${scenename}, null, MERGE, NOBLEND);`
    );
  }


  //Se crean los hotspots del activo

  /* private createHotspots(ath, atv, scene) {
    var hs_name = "hs_" + scene;
    this.panoramic.call("addhotspot(" + hs_name + ")");
    this.panoramic.set(
      "hotspot[" + hs_name + "].url",
      "./assets/panoramic/skin/vtourskin_hotspot.png"
    );
    this.panoramic.set("hotspot[" + hs_name + "].ath", ath);
    this.panoramic.set("hotspot[" + hs_name + "].atv", atv);
    this.panoramic.set(
      "hotspot[" + hs_name + "].loadstyle('skin_hotspotstyle')"
    );

    if (this.panoramic.get("device.html5")) {
      this.panoramic.set(
        "hotspot[" + hs_name + "].onclick",
        function (scene) {
          this.panoramic.call("loadscene(" + scene + ", null, MERGE);");
        }.bind(this, scene, this.panoramic)
      );
    } else {
      this.panoramic.set(
        "hotspot[" + hs_name + "].onclick",
        "js( alert(calc('hotspot \"' + name + '\" clicked')) );"
      );
    }
  } */

  /*  addHotspots() {
     if (this.panoramic) {
       var scene = this.panoramic.get("scene[get(xml.scene)]");
       var sceneDown = this.panoramic.get("scene").getItem(scene.index - 1);
       var sceneUp = this.panoramic.get("scene").getItem(scene.index + 1);
 
       var ath = this.panoramic.get("view.hlookat");
       var atv = this.panoramic.get("view.vlookat");
       var style = "skin_hotspotstyle";
 
       if (sceneUp !== undefined) {
         this.createHotspots(ath, atv, sceneUp.name);
       }
 
       if (sceneDown !== undefined) {
         ath = -1 * ath;
         this.createHotspots(ath, atv, sceneDown.name);
       }
     }
   } */


  addActive(dialog, ModalComponent, ModalRemoveComponent) {
    this.panoramic.call("screentosphere(mouse.x,mouse.y,m_ath,m_atv);");
    var posX = this.panoramic.get("m_ath");
    var posY = this.panoramic.get("m_atv");
    var uniqname = "hs" + Date.now();

    var scene = this.panoramic.get("scene[get(xml.scene)]");
    var view = this.panoramic.get("view");

    var hlookat = view.hlookat;
    var vlookat = view.vlookat;
    var fov = view.fov;
    var lat = scene.lat;
    var lng = scene.lng;
    var name = scene.name;

    dialog
      .open(ModalComponent, {
        data: {
          scene: name,
          posX: posX,
          posY: posY,
          lat: lat,
          lng: lng,
        },
      })
      .afterClosed()
      .subscribe((response) => {
        if (response) {
          let id = response.data.formulario_captura_id;
          let nameActive = response.data.formulario_captura_nombre;
          this.panoramic.call("addhotspot( hs_" + id + ");");
          this.panoramic.set(
            "hotspot[ hs_" + id + "].url",
            "./assets/img/property.png"
          );
          this.panoramic.call("set(hotspot[ hs_" + id + "].ath," + posX + ");");
          this.panoramic.call(
            "set(hotspot[ hs_" + id + "].atv, " + posY + ");"
          );
          this.panoramic.call(
            "hotspot[ hs_" + id + "].loadstyle('hotspot_ani_white');"
          );
          this.panoramic.set(
            "hotspot[ hs_" + id + "].onclick",
            function () {
              const dialogConfig = new MatDialogConfig();
              dialogConfig.disableClose = true;
              dialogConfig.autoFocus = false;
              dialogConfig.closeOnNavigation = false;
              dialogConfig.data = {
                id: id,
                name: nameActive,
                lat: lat,
                lng: lng,
              };
              dialog.open(ModalRemoveComponent, dialogConfig);
            }.bind(this)
          );
        }
      });
  }

  //Crea los hotspots en el tour de los activos creados
  addPoints(dialog, ModalRemoveComponent) {
    var filter = {
      "formulario_id": this.mapService.getCurrentFormId()
    }
    this.activeService.getActivesFilter(filter).subscribe((data: {}) => {
      var panoramic = this.panoramic;
      Object.entries(data["SDTFormularioCapturaFiltro"]).forEach(function ([key, val]) {
        var scene = panoramic.get("scene[get(xml.scene)]");
        if (scene) {
          if (scene.name == val["formulario_captura_scene"]) {
            panoramic.call(
              "addhotspot( hs_" + val["formulario_captura_id"] + ");"
            );
            panoramic.set(
              "hotspot[ hs_" + val["formulario_captura_id"] + "].url",
              "./assets/img/property.png"
            );
            panoramic.call(
              "set(hotspot[ hs_" +
              val["formulario_captura_id"] +
              "].atv," +
              val["formulario_captura_y"] +
              ");"
            );
            panoramic.call(
              "set(hotspot[ hs_" +
              val["formulario_captura_id"] +
              "].ath, " +
              val["formulario_captura_x"] +
              ");"
            );
            panoramic.call(
              "hotspot[ hs_" +
              val["formulario_captura_id"] +
              "].loadstyle('hotspot_ani_white');"
            );
            panoramic.set(
              "hotspot[ hs_" + val["formulario_captura_id"] + "].onclick",
              function () {
                dialog.open(ModalRemoveComponent, {
                  autoFocus: false,
                  data: {
                    id: val["formulario_captura_id"],
                    name: val["formulario_captura_nombre"],
                    lat: val["formulario_captura_latitud"],
                    lng: val["formulario_captura_longitud"],
                    hash: val["gx_md5_hash"],
                  },
                });
              }.bind(this)
            );
          }
        }

      });
    });
  }

  deleteHotspot(id) {
    this.panoramic.call("removehotspot( hs_" + id + ");");
  }
}
